import { __decorate, __extends } from "tslib";
import { Options } from 'vue-class-component';
import AvalonGTView from '@/utils/libs/BaseView';
import CommonConfig from '@/common/CommonConfig';
import { PageService } from '@/views/copy/taskcenter/import';
import SVGA from 'svgaplayerweb';
var HuanxunKnighthood = /** @class */ (function (_super) {
    __extends(HuanxunKnighthood, _super);
    function HuanxunKnighthood() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navH = 0;
        _this.statusH = 0;
        // 升级方式列表（与 indexKnighthood 一致）
        _this.upgradeList = CommonConfig.Common.huanxunUpgradeList;
        // 爵位等级列表
        _this.knighthoodList = [];
        _this.isShowNav = true;
        _this.isFix = false;
        _this.nobilityInfo = {};
        _this.title = '';
        _this.loading = false;
        _this.equipment = '';
        return _this;
    }
    HuanxunKnighthood.prototype.created = function () {
        this.navH = this.awlGlobalState.urlInitParams.navH;
        this.statusH = this.awlGlobalState.urlInitParams.statusH;
        this.loading = true;
        this.equipment = this.awlGlobalConfig.isEquipmentEnvironment();
        this.getNobilityInfo();
        window.addEventListener('scroll', this.handleScroll);
    };
    HuanxunKnighthood.prototype.getNobilityInfo = function () {
        var _this = this;
        PageService.getNobilityInfo({
            targetUserId: this.awlGlobalState.urlInitParams.id,
            os: this.equipment == 'Android' ? '1' : '2',
            osv: this.awlGlobalState.urlInitParams.version,
            channel: this.equipment == 'Android' ? '' : 'apple',
        })
            .then(function (data) {
            _this.loading = false;
            _this.nobilityInfo = data;
            _this.knighthoodList = data.nobilityLevel;
            if (data.avatarFrameSvg) {
                setTimeout(function () {
                    _this.playAni();
                }, 100);
            }
            _this.title = '财富等级';
        })
            .catch(function () {
            _this.loading = false;
        });
    };
    HuanxunKnighthood.prototype.playAni = function () {
        var _this = this;
        if (this.player) {
            this.player.clear();
        }
        this.player = new SVGA.Player('#svgBorder');
        var parser = new SVGA.Parser();
        parser.load(this.nobilityInfo.avatarFrameSvg, function (videoItem) {
            _this.player.setVideoItem(videoItem);
            _this.player.startAnimation();
        });
    };
    HuanxunKnighthood.prototype.clearAni = function () {
        if (this.player) {
            this.player.clear();
        }
    };
    HuanxunKnighthood.prototype.handleScroll = function () {
        var imgCWidth = window.screen.width;
        var topHeight = Math.ceil(imgCWidth / (330 / 299)) - Number(this.navH) - Number(70);
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.isShowNav = false;
        this.isFix = false;
        if (Number(topHeight) - Number(scrollTop) <= 10) {
            this.isFix = true;
        }
        if (scrollTop <= 0) {
            this.isShowNav = true;
        }
    };
    HuanxunKnighthood.prototype.toBack = function () {
        if (Number(this.awlGlobalState.pageJump) <= 1) {
            this.globalCommit('setting_pageJump', 1);
            this.awlGlobalConfig.onBack();
            return false;
        }
        else {
            this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) - 1);
            this.$router.go(-1);
        }
    };
    HuanxunKnighthood.prototype.toFortuneList = function () {
        var param = {
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.$router.push({
            path: '/nav/fortuneList',
            query: param,
        });
    };
    HuanxunKnighthood.prototype.unmounted = function () {
        window.removeEventListener('scroll', this.handleScroll);
        this.clearAni();
    };
    HuanxunKnighthood = __decorate([
        Options({
            name: 'HuanxunKnighthood',
        })
    ], HuanxunKnighthood);
    return HuanxunKnighthood;
}(AvalonGTView.BaseView));
export default HuanxunKnighthood;
